import { translate } from '@cashfree-intl/coherent';
import { TRANSACTION_STATUS_CHECKBOX_OPTIONS } from 'utils/constants';
import { FLOW_WISE_RECON } from './constants';

export const validate = values => {
  const errors = {};
  const { fileName, settlementId, reportType } = values;

  const isValidFileName = /^[a-zA-Z0-9 ._-]+$/gi.test(fileName.trim());

  if (!isValidFileName) {
    errors.fileName = `${translate(
      'report_name_must_be_alphanumeric_and_can_contain_only_spaces_and_characters',
    )}`;
  } else if (!values.fileName) {
    errors.fileName = `${translate('this_field_cannot_be_left_blank')}`;
  }

  if (values.vendorReconReportType) {
    if (values.vendorReconReportType.value === 'SETTLEMENTS') {
      if (!settlementId || !settlementId.trim())
        errors.settlementId = `${translate('this_field_cannot_be_left_blank')}`;
      else if (!/^[0-9]+$/gi.test(settlementId.trim()))
        errors.settlementId = `${translate('only_numbers_are_allowed')}`;
    } else if (errors.settlementId) {
      errors.settlementId = '';
    }
  }

  if (reportType.key === 'TRANSACTIONS') {
    const checkboxSelected = Object.keys(
      TRANSACTION_STATUS_CHECKBOX_OPTIONS,
      // eslint-disable-next-line no-prototype-builtins
    ).filter(val => values.hasOwnProperty(val) && !!values[val]);

    if (!checkboxSelected.length) {
      errors.status = `${translate('please_select_atleast_one_checkbox')}`;
    }
  }
  // add a condition for flowwise recon that PG is required, see what is the field name for PG dropdown
  if (reportType.key === FLOW_WISE_RECON) {
    if (!values.paymentGateway || values.paymentGateway?.length === 0) {
      errors.paymentGateway = `${translate('this_field_cannot_be_left_blank')}`;
    }
  }
  return errors;
};

export default validate;
